export const intlHiIn = {
    测试: 'परीक्षा',
    登录: 'लॉग इन करें',
    注册: 'पंजीकरण करवाना',
    变量的例子: 'चर {value} का उदाहरण',
    多样式多语言例子: '<span style="font-size: 12px;color: #d7cab3;">चर का उदाहरण <span style="font-size: 16px;color: #fff;font-weight: 600;">@money</span></span>',
    体育: 'खेल',
    存款: 'जमा',
    提款: 'निकासी',
    请登录: 'कृपया लॉगिन करें',
    余额刷新成功: 'संतुलन ताज़ा सफलता',
    我的金额: 'मेरे पैसे',
    我的邀请码: 'मेरा आमंत्रण कोड',
    复制成功: 'कॉपी सफलता',
    下一次抽奖: 'अगला ड्रा',
    您没有抽奖的机会: 'आपके पास ड्रा करने का कोई मौका नहीं है',
    规则: 'नियम',
    我的: 'मेरा',
    我的信息: 'मेरी जानकारी',
    资金详情: 'धन विवरण',
    在线客服: 'ऑनलाइन ग्राहक सेवा',
    客服暂未配置: 'ग्राहक सेवा कॉन्फ़िगर नहीं की गई',
    促销码: 'पदोन्नति कोड',
    请输入促销码: 'कृपया प्रमोशन कोड दर्ज करें',
    验证码: 'सत्यापन कोड',
    请输入验证码: 'कृपया सत्यापन कोड दर्ज करें',
    提交: 'जमा करना',
    退出登录: 'लॉग आउट',
    提示: 'संकेत देना',
    '确定要退出登录吗？': 'क्या आप लॉग आउट करना चाहते हैं?',
    取消: 'रद्द करना',
    确定: 'पुष्टि करना',
    '升级到 {value} 还需要 {value}': '{value1} में अपग्रेड करने के लिए अभी भी {value2} की आवश्यकता है',
    头像: 'अवतार',
    用户名: 'उपयोगकर्ता नाम',
    登录密码: 'लॉगिन पासवर्ड',
    提现密码: 'निकासी पासवर्ड',
    修改提现密码: 'निकासी पासवर्ड बदलें',
    修改密码: 'पासवर्ड बदलें',
    设置提现密码: 'निकासी पासवर्ड सेट करें',
    请输入提现密码: 'कृपया निकासी पासवर्ड दर्ज करें',
    请再次输入提现密码: 'कृपया निकासी पासवर्ड पुनः दर्ज करें',
    提现密码不能为空: 'निकासी पासवर्ड खाली नहीं हो सकता',
    确认提现密码不能为空: 'निकासी की पुष्टि पासवर्ड खाली नहीं हो सकता',
    提现密码格式不正确: 'गलत निकासी पासवर्ड प्रारूप',
    确认提现密码格式不正确: 'निकासी पासवर्ड प्रारूप की गलत पुष्टि',
    提现密码和确认提现密码不一致: 'निकासी पासवर्ड और निकासी पुष्टि पासवर्ड मेल नहीं खाते',
    设置提现密码成功: 'निकासी पासवर्ड सफलतापूर्वक सेट करें',
    请输入旧密码: 'कृपया पुराना पासवर्ड दर्ज करें',
    请输入新密码: 'कृपया नया पासवर्ड दर्ज करें',
    请再次输入新密码: 'कृपया नया पासवर्ड पुनः दर्ज करें',
    旧密码不能为空: 'पुराना पासवर्ड खाली नहीं किया जा सकता',
    新密码不能为空: 'नया पासवर्ड रिक्त नहीं हो सकता',
    确认密码不能为空: 'पुष्टिकरण पासवर्ड रिक्त नहीं हो सकता',
    '旧密码格式不正确, 请输入6-18位字母或数字': 'पुराना पासवर्ड प्रारूप गलत है, कृपया 6-18 अक्षर या संख्या दर्ज करें',
    '新密码格式不正确, 请输入6-18位字母或数字': 'नया पासवर्ड प्रारूप गलत है, कृपया 6-18 अक्षर या संख्या दर्ज करें',
    '确认密码格式不正确, 请输入6-18位字母或数字': 'पुष्टिकरण पासवर्ड प्रारूप गलत है, कृपया 6-18 अक्षर या संख्या दर्ज करें',
    新密码和确认密码不一致: 'नया पासवर्ड और पुष्टिकरण पासवर्ड मेल नहीं खाते',
    '修改密码成功, 请重新登录': 'पासवर्ड सफलतापूर्वक बदल दिया गया, कृपया पुनः लॉग इन करें',
    修改提现密码成功: 'निकासी पासवर्ड सफलतापूर्वक बदल दिया गया',
    选择头像: 'अवतार चुनें',
    今天: 'आज',
    昨天: 'कल',
    一个月内: 'एक महीने के अंदर',
    余额: 'संतुलन',
    编号: 'संख्या',
    备注: 'टिप्पणी',
    提现金额: 'निकाली गयी राशि',
    充值: 'पुनर्भरण',
    账变: 'खाता परिवर्तन',
    所有类型: 'सभी प्रकार के',
    每天: 'रोज रोज',
    每周: 'हर हफ्ते',
    每月: 'प्रत्येक माह',
    活动名称: 'गतिविधि का नाम',
    优惠金额: 'अधिमान्य राशि',
    申请时间: 'आवेदन समय',
    '发放/审核时间': 'वितरण/लेखा परीक्षा समय',
    状态: 'स्थिति',
    活动奖项: 'गतिविधि पुरस्कार',
    排名: 'रैंकिंग',
    每日列表: 'दैनिक सूची',
    每周列表: 'साप्ताहिक सूची',
    每月列表: 'मासिक सूची',
    没有排名: 'कोई रैंकिंग नहीं',
    我的投注: 'मेरी शर्त',
    我的奖励: 'मेरा इनाम',
    剩余排名: 'शेष रैंकिंग',
    空缺: 'खाली',
    奖励: 'इनाम',
    总投注: 'कुल दांव',
    投注: 'बेट',
    '占所有玩家总投注额的 {value} %': 'सभी खिलाड़ियों के कुल दांव का {value} % लें',
    暂无数据: 'कोई डेटा नहीं',
    首页: 'घर',
    优惠活动: 'गतिविधि',
    推广: 'पदोन्नति',
    请选择: 'कृपया चुनें',
    年: 'वर्ष',
    月: 'महीना',
    日: 'दिन',
    上午: 'सुबह',
    下午: 'दोपहर',
    天: 'दिन',
    周: 'सप्ताह',
    投注返利详情:
        '<span style="font-size: 10px;color: #d7cab3;">आपकी टीम की कुल शर्त राशि {value1} है, और आप प्रति माह <span style="font-size: 14px;color: #fff;font- वज़न: 600;">{value2}</span> तक प्राप्त कर सकते हैं।</span>',
    优惠活动详情: 'प्रमोशन विवरण',
    活动申请: 'गतिविधि आवेदन',
    加载中: 'लोड हो रहा है',
    申请: 'आवेदन करना',
    申请成功: 'आवेदन सफल',
    申请失败: 'आवेदन विफल',
    所有记录: 'सभी रिकॉर्ड',
    申请中: 'को लागू करने',
    发放成功: 'जारीकरण सफल',
    审核失败: 'समीक्षा विफल',
    活动申请记录: 'गतिविधि आवेदन रिकॉर्ड',
    原因: 'कारण',
    邮件: 'मेल',
    邮件最多可保存30天: 'मेल को 30 दिनों तक सुरक्षित रखा जा सकता है',
    删除已读: 'मिटाएं पढ़ें',
    全部接收: 'सभी प्राप्त करें',
    邮件详情: 'मेल विवरण',
    删除: 'मिटाना',
    确认密码: 'पासवर्ड की पुष्टि कीजिये',
    真实姓名: 'वास्तविक नाम',
    姓: 'उपनाम',
    名: 'पहला नाम',
    邮箱: 'ईमेल',
    邮箱验证码: 'ईमेल सत्यापन कोड',
    发送: 'भेजना',
    手机号: 'मोबाइल नंबर',
    手机验证码: 'मोबाइल सत्यापन कोड',
    出生日期: 'जन्म की तारीख',
    twitter: 'twitter',
    facebook: 'फेसबुक',
    证件类型: 'आईडी का प्रकार',
    证件号: 'आईडी नंबर',
    推广码: 'पदोन्नति कोड',
    优惠码: 'रिडेम्पशन कोड',
    登录成功: 'लॉग इन सफल',
    登录失败: 'लॉगिन विफल',
    登录账号: 'लॉगिन खाता',
    请输入正确的邮箱: 'कृपया एक मान्य ईमेल पता प्रविष्ट करें',
    请选择手机区号: 'कृपया मोबाइल क्षेत्र कोड चुनें',
    手机号校验: 'कृपया 6-12 अंकों का मोबाइल नंबर दर्ज करें',
    请输入10位手机号: 'कृपया 10 अंकों का मोबाइल नंबर दर्ज करें',
    验证码发送成功: 'सत्यापन कोड सफलतापूर्वक भेजा गया',
    用户名验证: 'उपयोगकर्ता नाम (6-15) अक्षरों और छोटे अक्षरों और संख्याओं के संयोजन से शुरू होना चाहिए',
    用户名不能以test为起始: 'उपयोगकर्ता नाम परीक्षण से शुरू नहीं हो सकता',
    密码必须为6位数字: 'पासवर्ड 6 अंकों का होना चाहिए',
    确认密码必须为6位数字: 'पुष्टि पासवर्ड 6 अंकों का होना चाहिए',
    两次输入的密码不一致: 'दो बार दर्ज करें पासवर्ड मेल नहीं खाता.',
    登录密码验证: 'पासवर्ड (6 से 18 अक्षर) अक्षरों, संख्याओं या विशेष अक्षरों का संयोजन होना चाहिए',
    确认登录密码验证: 'पुष्टि करें कि पासवर्ड (6 से 18 अक्षर) अक्षरों, संख्याओं या विशेष अक्षरों का संयोजन होना चाहिए',
    请输入正确的姓名: 'कृपया अपना सही नाम दर्ज करें',
    请输入出生日期: 'अपनी जन्मतिथि भरें',
    请输入您的twitter账号: 'कृपया अपना {value} खाता नंबर दर्ज करें',
    请输入您的facebook账号: 'कृपया अपना फेसबुक खाता दर्ज करें',
    推广码校验: 'पुष्टि करें कि आपने सही प्रचार कोड (1 से 8 अंक) दर्ज किया है',
    推广码校验2: 'कृपया प्रचार कोड दर्ज करें',
    请点击开始验证: 'कृपया सत्यापन प्रारंभ करें पर क्लिक करें',
    请输入邮箱验证码: 'कृपया ईमेल सत्यापन कोड दर्ज करें',
    请输入手机验证码: 'कृपया मोबाइल सत्यापन कोड दर्ज करें',
    请输入姓: 'कृपया अपना अंतिम नाम दर्ज करें',
    请输入名: 'कृपया अपना पहला नाम दें',
    请输入证件号: 'कृपया अपना आईडी नंबर दर्ज करें',
    请输入有效的CURP: 'कृपया मान्य CURP दर्ज करें',
    '请输入11~14位数字': 'कृपया 11 से 14 अंक दर्ज करें',
    请选择证件类型: 'कृपया आईडी प्रकार चुनें',
    请接受服务条款: 'कृपया सेवा के नियमों को स्वीकार करें',
    邀请奖励: 'आमंत्रण पुरस्कार',
    问题1: 'प्रश्न 1: कमीशन विभाजन का क्या अर्थ है?',
    回答1: 'A1: दोस्तों को एप्लिकेशन में शामिल होने के लिए आमंत्रित करने और अपने निमंत्रण कोड को बांधने के बाद, आपको एक निश्चित अनुपात में इन दोस्तों की खपत के आधार पर अतिरिक्त कमीशन प्राप्त होगा।',
    问题2: 'प्रश्न 2: क्लब का क्या मतलब है?',
    回答2: 'A2: आपके क्लब में आपके सभी एजेंट टीम के सदस्य शामिल हैं।',
    问题3: 'प्रश्न 3: मैं उच्च क्लब स्टार रेटिंग तक कैसे अपग्रेड कर सकता हूं?',
    回答3: 'A3: आप ज़्यादा दोस्तों को आमंत्रित करके या टीम के सदस्यों के साथ मिलकर अपग्रेड कर सकते हैं। ज़्यादा विस्तृत जानकारी के लिए, कृपया अपग्रेड आवश्यकताएँ तालिका देखें।',
    问题4: 'प्रश्न 4: मैं पुरस्कार कैसे प्राप्त कर सकता हूँ?',
    回答4: 'A4: जब आपके मित्र या आपके मित्रों के आमंत्रण पर खरीदारी की जाती है, तो आपको तुरंत सभी पुरस्कार प्राप्त होंगे, जो आपके कमीशन खाते में जमा हो जाएंगे और अगले दिन आपके वॉलेट में वापस लिए जा सकते हैं।',
    问题5: 'प्रश्न 5: क्या पुरस्कार वापस लेने के लिए कोई शर्त आवश्यक है?',
    回答5: 'A5: इसमें एक बार की शर्त लगाने की आवश्यकता है।',
    问题6: 'प्रश्न 6: मैं अपने पुरस्कारों का उपयोग कब कर सकता हूँ?',
    回答6: 'A6: आप अपने रिवॉर्ड को अगले दिन खर्च करने के लिए अपने वॉलेट में वापस ले सकते हैं। कभी-कभी इसमें थोड़ी देरी हो सकती है। आपकी समझदारी के लिए धन्यवाद।',
    佣金比例详情: '※आप A, B और C द्वारा लगाए गए सभी दांवों और रिचार्ज राशियों से एक निश्चित प्रतिशत कमीशन प्राप्त कर सकते हैं। कृपया विशिष्ट कमीशन दरों के लिए निम्नलिखित आरेख देखें।',
    返利比例详情: '※अलग-अलग खेलों में अलग-अलग छूट अनुपात होते हैं। आप अपने क्लब की स्टार रेटिंग को अपग्रेड करके छूट अनुपात भी बढ़ा सकते हैं।',
    立即邀请: 'अभी आमंत्रित करें!',
    佣金率: 'आयोग दर',
    流水返利: 'टर्नओवर पर छूट',
    俱乐部之星: 'क्लब सितारे',
    佣金等级: 'Lv{value} कमीशन',
    首存返利: 'प्रथम जमा पर छूट',
    什么是俱乐部: 'क्लब क्या है?',
    俱乐部的星级越高介绍: 'आप और आपके सभी एजेंट मिलकर अपना क्लब बनाते हैं। क्लब की स्टार रेटिंग जितनी अधिक होगी, छूट अनुपात उतना ही अधिक होगा।',
    你的俱乐部: 'आपका क्लब',
    如何提高俱乐部的星级: 'क्लब की स्टार रेटिंग कैसे बढ़ाई जाए?',
    代理要求: 'एजेंट की आवश्यकताएं',
    投注要求: 'सट्टेबाजी की आवश्यकताएं',
    无星: 'कोई नहीं स्टार',
    一星: 'एक सितारा',
    二星: 'दो सितारा',
    三星: 'तीन स्टार',
    全部: 'सभी',
    我的奖金: 'मेरा बोनस',
    下一级: 'अगला स्तर',
    累计存款: 'जमाराशि {value} संचित करें',
    每日提款限额: 'दैनिक निकासी सीमा',
    每日提现次数: 'दैनिक निकासी की संख्या',
    每月累计存款升级VIP等级: 'मासिक संचयी जमा एक अपग्रेड वीआईपी स्तर',
    等级: 'स्तर',
    月度奖金: 'मासिक बोनस',
    等级升级奖励: 'स्तर उन्नयन बोनस',
    现金奖励发放时间: 'नकद बोनस: इस महीने के अंत में आपके वीआईपी स्तर के आधार पर, यह पुरस्कार आपको अगले महीने की पहली तारीख को सुबह 10 बजे भेजा जाएगा।',
    晋级彩金: 'अपग्रेड बोनस',
    每月奖金: 'मासिक बोनस',
    投注返水: 'शर्त छूट',
    网络问题: 'नेटवर्क की समस्या',
    '检测到您目前没有网络连接，请开启网络后再试。': 'पता चला है कि आपके पास वर्तमान में कोई नेटवर्क कनेक्शन नहीं है, कृपया नेटवर्क चालू करने के बाद पुनः प्रयास करें।',
    设置: 'समायोजन',
    总奖励: 'कुल पुरस्कार',
    邀请总数: 'कुल आमंत्रण',
    邀请有效用户数量: 'आपने कुल {value1} मित्रों को आमंत्रित किया है, जिनमें से {value2} वैध उपयोगकर्ता हैं।',
    邀请新客户获得: 'एक नए ग्राहक को आमंत्रित करें',
    邀请好友可获得: 'आमंत्रित मित्रों को मिलता है',
    邀请好友获取金钱: 'पैसे पाने के लिए दोस्तों को आमंत्रित करें',
    每日邀请次数: 'दैनिक आमंत्रण समय: {value}',
    邀请300位好友可获得: '{value} मित्रों को आमंत्रित करें',
    如何参与: 'कैसे भाग लें',
    步骤1: 'चरण 1: पंजीकरण करें',
    步骤2: 'चरण 2: मित्रों को आमंत्रित करने के लिए किसी भी आमंत्रण पृष्ठ पर क्लिक करें',
    步骤3: 'चरण 3: मित्र रजिस्टर करें और आमंत्रण कोड दर्ज करें',
    步骤4: 'चरण 4: मित्र {value} जमा करता है',
    步骤5: 'चरण 5: पुरस्कार प्राप्त करें',
    什么是有效邀请用户: 'वैध आमंत्रित उपयोगकर्ता कौन है?',
    有效邀请用户描述: 'वैध आमंत्रित उपयोगकर्ता वह है जिसने {value} से अधिक संचयी राशि जमा की है',
    奖励兑换: 'पुरस्कार मोचन',
    奖励兑换步骤1: 'प्रत्येक सफल आमंत्रण के लिए, आमंत्रितकर्ता को {value1} प्राप्त होता है।',
    奖励兑换步骤2: 'प्रत्यक्ष एजेंट (आमंत्रितकर्ता के वरिष्ठ) को {value} का बोनस मिलता है।',
    奖励兑换步骤3: 'प्रत्यक्ष एजेंट के वरिष्ठ एजेंट को {value} का बोनस मिलता है।',
    奖励兑换步骤4: 'आमंत्रित उपयोगकर्ता को भी {value} का बोनस मिलता है।',
    奖励兑换步骤5: 'इनाम का इस्तेमाल गेम खेलने के लिए किया जा सकता है।',
    奖励兑换步骤6: 'पुरस्कार स्वचालित रूप से सिस्टम द्वारा वितरित किए जाते हैं।',
    活动解释权: '{value} इस गतिविधि के अंतिम व्याख्यान का अधिकार रखते हैं।',
    '安装权限未被授予，无法打开APK文件': 'स्थापना की अनुमति नहीं दी गई, APK फ़ाइल खोलने में असमर्थ',
    '权限已授予，正在尝试打开APK...': 'अनुमति दे दी गई, APK खोलने का प्रयास किया जा रहा है...',
    立即更新: 'अभी अद्यतन करें',
    稍后更新: 'बाद में अपडेट करें',
    版本号不符合规范: 'संस्करण संख्या विनिर्देशों को पूरा नहीं करती',
    邀请人数: 'आमंत्रण संख्या',
    奖励详情: 'इनाम का विवरण',
    '网络错误, 请稍后重试!': 'नेटवर्क त्रुटि, कृपया बाद में पुनः प्रयास करें!',
    存款金额: 'जमा राशि',
    奖励金额: 'पुरस्कार राशि',
    立即存款: 'अभी जमा करें',
    今天不再显示: 'आज फिर मत दिखाना',
    倒计时: 'उलटी गिनती',
    应用未安装: 'एप्लिकेशन इंस्टॉल नहीं है',
    邀请码: 'आमंत्रण संकेत',
    请输入用户名: 'अपने उपयोगकर्ता नाम दर्ज करें',
    密码: 'पासवर्ड',
    请输入密码: 'अपना पासवर्ड दर्ज करें',
    '密码必须为(6~18位)字母或数字组合': 'पासवर्ड (6~18 अक्षर) अक्षरों या संख्याओं का संयोजन होना चाहिए',
    忘记密码: 'पासवर्ड भूल गए',
    注册账号: 'रजिस्टर खाता',
    重置密码: 'पासवर्ड रीसेट',
    '确定进入游戏吗?': 'क्या आप वाकई खेल में प्रवेश करना चाहते हैं?',
    进入游戏失败: 'खेल में प्रवेश करने में असफल',
    '确定要支付吗?': 'क्या आप वाकई भुगतान करना चाहते हैं?',
    充值请求已取消: 'टॉप-अप अनुरोध रद्द कर दिया गया है',
    已提交充值请求: 'टॉप-अप अनुरोध प्रस्तुत कर दिया गया है',
    存款方式: 'जमा विधि',
    存款账户: 'जमा खाता',
    收款户名: ' प्राप्तकर्ता का नाम:',
    银行账户: ' बैंक खाता:',
    开户地址: ' बैंक शाखा का पता:',
    开户银行: ' बैंक का नाम:',
    单笔范围: ' एकल लेनदेन रेंज:',
    存款优惠: 'जमा प्रस्ताव',
    最高奖金: 'अधिकतम बोनस:',
    剩余数量: ' बची हुई मात्रा:',
    不选择: 'चयन न करें',
    请选择优惠: 'कृपया एक प्रस्ताव चुनें',
    充值优惠详情: 'टॉप-अप ऑफर विवरण',
    详情: 'विवरण',
    最小额: 'न्यू.',
    最大额: 'मैक्स',
    存款提示: 'जमा युक्तियाँ',
    存款提示1: 'प्रत्येक जमा राशि 1-5 मिनट के भीतर जमा कर दी जाएगी',
    存款提示2: 'जमा संबंधी समस्याओं के समाधान के लिए आप कभी भी ग्राहक सेवा से संपर्क कर सकते हैं',
    充值金额不能小于最小金额: 'टॉप-अप राशि न्यूनतम राशि से कम नहीं हो सकती',
    立即支付: 'अब भुगतान करें',
    下一步: 'अगला कदम',
    USDT数量: 'USDT मात्रा',
    充值金额: 'टॉप-अप राशि',
    复制: 'प्रतिलिपि',
    TXID后五位: 'TXID के अंतिम पाँच अंक',
    汇款信息: 'प्रेषण जानकारी',
    '(必填)请输入汇款人姓名或者卡号后四位': '(आवश्यक) कृपया प्रेषक का नाम या कार्ड नंबर के अंतिम चार अंक दर्ज करें',
    上一步: 'पिछला कदम',
    备注信息不允许为空: 'टिप्पणी जानकारी रिक्त नहीं हो सकती',
    收款银行: 'प्राप्त बैंक',
    银行地址: 'बैंक पता',
    PIX类型: 'पिक्स प्रकार',
    账号名称: 'खाता नाम',
    收款账户: 'प्राप्ति खाता',
    PIX账号: 'PIX खाता',
    选择钱包类型: 'वॉलेट प्रकार चुनें',
    '获取钱包列表失败, 请联系客服': 'वॉलेट सूची प्राप्त करने में विफल, कृपया ग्राहक सेवा से संपर्क करें',
    请选择钱包类型: 'कृपया वॉलेट प्रकार चुनें',
    收款地址: 'प्राप्ति पता',
    当前汇率: 'वर्तमान विनिमय दर',
    转换金额: 'परिवर्तित राशि',
    单日提现金额上限: 'दैनिक निकासी राशि सीमा:',
    单日提现次数上限: ' दैनिक निकासी आवृत्ति सीमा:',
    单笔最低提现额度: ' न्यूनतम एकल निकासी राशि:',
    单笔最高提现额度: ' अधिकतम एकल निकासी राशि:',
    提现时间段: ' निकासी समय अवधि:',
    普通余额: ' नियमित शेष:',
    代理余额: ' एजेंट बैलेंस:',
    普通余额可兑换USDT数量: ' नियमित शेष राशि से परिवर्तनीय USDT:',
    代理余额可兑换USDT数量: ' एजेंट बैलेंस से परिवर्तनीय USDT:',
    '你还没绑定三方钱包哦!': 'आपने अभी तक कोई तृतीय-पक्ष वॉलेट लिंक नहीं किया है!',
    选择钱包: 'वॉलेट चुनें',
    请输入提现金额: 'कृपया निकासी राशि दर्ज करें',
    请输入有效金额: 'कृपया मान्य राशि दर्ज करें',
    请输入正整数金额: 'कृपया एक धनात्मक पूर्णांक राशि दर्ज करें',
    普通余额不足: 'नियमित शेष राशि अपर्याप्त',
    代理余额不足: 'अपर्याप्त एजेंट संतुलन',
    请选择三方钱包: 'कृपया किसी तृतीय-पक्ष वॉलेट का चयन करें',
    '你还没虚拟货币地址哦!': 'आपके पास अभी तक कोई क्रिप्टोकरेंसी पता नहीं है!',
    请输入要兑换的USDT数量: 'कृपया विनिमय की जाने वाली USDT राशि दर्ज करें',
    请输入有效枚数: 'कृपया मान्य मात्रा दर्ज करें',
    请输入正整数枚数: 'कृपया एक धनात्मक पूर्णांक मात्रा दर्ज करें',
    提款数量不能大于可提款USDT数量: 'निकासी राशि उपलब्ध USDT राशि से अधिक नहीं हो सकती',
    请输入提款金额: 'कृपया निकासी राशि दर्ज करें',
    请选择钱包: 'कृपया एक वॉलेट चुनें',
    '你还没绑定银行卡哦!': 'आपने अभी तक कोई बैंक कार्ड लिंक नहीं किया है!',
    选择银行卡: 'बैंक कार्ड चुनें',
    请选择银行卡: 'कृपया कोई बैंक कार्ड चुनें',
    '你还没绑定PIX哦!': 'आपने अभी तक कोई PIX लिंक नहीं किया है!',
    选择PIX: 'PIX चुनें',
    请选择PIX类型: 'कृपया PIX प्रकार चुनें',
    '你还没绑定支付宝哦!': 'आपने अभी तक Alipay लिंक नहीं किया है!',
    选择支付宝: 'अलीपे चुनें',
    请选择支付宝: 'कृपया Alipay चुनें',
    去绑定: 'लिंक पर जाएं',
    已选: 'चयनित',
    兑换全部: 'सभी का आदान-प्रदान करें',
    当前提款不在时间段内: 'वर्तमान निकासी समय अवधि के भीतर नहीं है',
    钱包中心: 'वॉलेट सेंटर',
    绑卡提示:
        'प्रिय उपयोगकर्ता, आपकी सूचना सुरक्षा के लिए, डिफ़ॉल्ट रूप से, आप केवल {value} कार्ड ही लिंक कर सकते हैं। यदि आपको जोड़ने या संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें',
    钱包地址: 'वॉलेट पता',
    请输入钱包地址: 'कृपया वॉलेट पता दर्ज करें',
    请输入字母或数字: 'कृपया अक्षर या संख्या दर्ज करें',
    钱包姓名: 'वॉलेट का नाम',
    请输入钱包姓名: 'कृपया वॉलेट का नाम दर्ज करें',
    持卡人姓名: 'कार्डधारक का नाम',
    钱包名称: 'वॉलेट का नाम',
    钱包账号: 'वॉलेट खाता',
    开户行地址: 'बैंक शाखा का पता',
    钱包类型: 'वॉलेट का प्रकार',
    "TRC20需以字母'T'开头的34位字符": "TRC20 में 'T' से शुरू होने वाले 34 अक्षर होने चाहिए",
    银行卡类型: 'बैंक कार्ड का प्रकार',
    请选择银行卡类型: 'कृपया बैंक कार्ड का प्रकार चुनें',
    请输入开户行地址: 'कृपया बैंक शाखा का पता दर्ज करें',
    已有银行卡号: 'मौजूदा बैंक कार्ड नंबर',
    请输入已有银行卡号: 'कृपया मौजूदा बैंक कार्ड नंबर दर्ज करें',
    银行卡账号: 'बैंक कार्ड खाता',
    请输入银行卡账号: 'कृपया बैंक कार्ड खाता दर्ज करें',
    请输入持卡人姓名: 'कृपया कार्डधारक का नाम दर्ज करें',
    银行名称: 'बैंक का नाम',
    银行账号: 'बैंक खाता',
    支付宝姓名: 'अलीपे नाम',
    请输入支付宝姓名: 'कृपया अलीपे नाम दर्ज करें',
    支付宝账号: 'अलीपे खाता',
    请输入支付宝账号: 'कृपया अलीपे खाता दर्ज करें',
    添加新账户: 'नया खाता जोड़ें',
    资料信息提交成功: 'जानकारी सफलतापूर्वक सबमिट की गई',
    联系地址: 'संपर्क पता',
    请输入联系地址: 'कृपया संपर्क पता दर्ज करें',
    完善信息: 'सूचना पूरा करें',
    请先完善个人信息: 'कृपया प्रयोगकर्ता जानकारी पूरा करें',
    请先选择优惠: 'कृपया अवसर चुनें',
    请输入PIX账号: 'कृपया PIX खाता दर्ज करें',
    活动金额: 'गतिविधि राशि',
    更换成功: 'प्रतिस्थापन सफल',
    注册成功: 'पंजीकरण सफलता',
    注册失败: 'पंजीकरण विफल रहा',
    请选择线路: 'कृपया लाइन चुनें',
    '线路{value}': 'लाइन {value}',
    存款前请先绑定银行卡: 'बटुए पहले बैंक कार्ड संशोधित करें',
    额度回收: 'वर्तमान राशि',
    一键刷新: 'एक क्लिक रिफ्रेश',
    一键回收: 'एक क्लिक रीसायकल',
    主平台金额: 'मुख्य मंच राशि',
    我的团队俱乐部: 'मेरी टीम क्लब',
    俱乐部星级: 'क्लब स्टार रेटिंग',
    俱乐部星级提示: 'आप और आपके सभी एजेंट मिलकर अपना क्लब बनाते हैं। क्लब की स्टार रेटिंग जितनी अधिक होगी, छूट अनुपात उतना ही अधिक होगा।',
    俱乐部成员: 'क्लब सदस्य',
    俱乐部投注: 'क्लब सट्टेबाजी',
    我的返佣: 'मेरा कमीशन:',
    投注返佣高达: 'सट्टेबाजी कमीशन तक',
    首次存款返佣: 'पहली जमा कमीशन',
    可领取: 'ले सकते हैं',
    领取: 'लें',
    领取成功: 'लेना सफल',
    领取失败: 'लेना विफल',
    今日奖励: 'आज का पुरस्कार',
    邀请朋友: 'दोस्तों को आमंत्रित करें',
    通过WhatsApp邀请: 'WhatsApp के माध्यम से आमंत्रित करें',
    保存图片: 'छवि सहेजें',
    分享: 'शेयर',
    从属数据: 'उप-डेटा',
    总人数: 'कुल लोग',
    本月: 'इस महीने',
    层级: 'स्तर',
    加入时间: 'समय में शामिल हों',
    佣金: 'कमीशन',
    提款历史记录: 'निकासी इतिहास रिकॉर्ड',
    邀请: 'आमंत्रण',
    邀请任务: 'आमंत्रण कार्य',
    时间: 'समय',
    佣金金额: 'कमीशन राशि',
    成功: 'सफल',
    下级: 'निचला स्तर',
    受邀人数: 'आमंत्रित लोग',
    佣金总额: 'कमीशन कुल राशि',
    提现公告: '{value1} ने सफलतापूर्वक {value2} निकाल लिए',
    个人资料: 'प्रोफ़ाइल',
    用户信息: 'उपयोगकर्ता जानकारी',
    昵称: 'उपयोगकर्ता नाम',
    今天1: 'आज',
    昨天1: 'कल',
    奖励详情1: 'पुरस्कार विवरण',
    投注1: 'बेट',
    存款1: 'जमा',
    状态1: 'स्थिति',
    邀请奖励高达: 'आमंत्रण पुरस्कार तक',
    平台名称: 'प्लेटफ़ॉर्म नाम',
    金额: 'राशि',
    刷新: 'पुनर्स्थापित करें',
    回收: 'पुनर्स्थापित करें',
    休眠提示: 'बहुत बार क्लिक किया गया है, कृपया {value} सेकंड बाद पुनः प्रयास करें',
    刷新成功: 'ताज़ा करना सफल',
    刷新失败: 'ताज़ा करना असफल',
    回收成功: 'पुनः प्राप्ति सफल',
    回收失败: 'पुनः प्राप्ति असफल',
    存款提示3: '1.प्रत्येक जमा राशि 1-5 मिनट के भीतर जमा कर दी जाएगी।',
    存款提示4: '2.जमा संबंधी समस्याओं के समाधान के लिए आप किसी भी समय ग्राहक सेवा से संपर्क कर सकते हैं।',
    提款提示: 'निकासी संबंधी सुझाव',
    提款提示1: 'सामान्य परिस्थितियों में, निकासी राशि लगभग 2 घंटे में आपके खाते में आ जाएगी, तथा अधिकतम समय 24 घंटे से अधिक नहीं होगा',
    钱包: 'वॉलेट',
    我的余额: 'मेरा शेष',
    绑定手机号: 'फ़ोन नंबर बाँधें',
    绑定成功: 'बाइंडिंग सफल',
    未绑定: 'अनबाउंड',
    验证码发送失败: 'सत्यापन कोड भेजना विफल',
    投注记录: 'बेट रिकॉर्ड',
    投注金额: 'बेट राशि',
    投注时间: 'बेट समय',
    订单号: 'आदेश संख्या',
    平台: 'प्लेटफ़ॉर्म',
    游戏名: 'खेल का नाम',
    玩法: 'खेलने का तरीका',
    投注模式: 'बेट मोड',
    有效投注: 'वैध बेट',
    盈亏金额: 'लाभ या हानि राशि',
    '1、功能优化、性能优化': '1. कार्यक्षमता अनुकूलन, प्रदर्शन अनुकूलन',
    '2、修复一些已知问题': '2. कुछ ज्ञात समस्याओं को ठीक करें',
    发现新版本: 'नया संस्करण पाया',
    奖励2: 'इनाम',
    下一次免费旋转: 'अगला मुफ़्त स्पिन',
    请输入正确的IFSC码: 'कृपया सही IFSC कोड दर्ज करें',
    记录: 'रिकॉर्ड करें',
    提款剩余时间: 'शेष निकासी समय',
    收集提现: 'जब आप {value} एकत्र करते हैं तो निकासी करें',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">केवल <span style="font-size: 13px;color: #e9b742;">{value}</span> जाने के लिए</span>',
    邀请好友获得免费旋转: 'एक मुफ्त स्पिन प्राप्त करने के लिए दोस्तों को आमंत्रित करें',
    选择您的奖励: 'अपना पुरस्कार चुनें',
    每日免费提款: 'निःशुल्क दैनिक निकासी',
    所有时间: 'सभी समय',
    本周: 'इस सप्ताह',
    上周: 'पिछले सप्ताह',
    QQ: 'QQ',
    微信: 'WeChat',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: 'फ़ोन नंबर का प्रारूप ग़लत है',
    请输入真实姓名: 'कृपया अपना वास्तविक नाम दर्ज करें',
    不限制: 'कोई सीमा नहीं',
    请输入订单号: 'कृपया ऑर्डर संख्या दर्ज करें',
    立即游戏: 'अब खेलते हैं',
    '存款 {value} 即可获得 {value} 次旋转。': 'जमा करें {value1} और पाएं {value2} बार स्पिन।',
    '1次': '{value} बार',
    历史: 'इतिहास',
    活动规则: 'गतिविधि नियम',
    游戏维护中: 'खेल के रखरखाव के अंतर्गत है',
    游戏维护时间: 'खेल के रखरखाव के अंतर्गत है,रखरखाव समय: {value}',
    快捷登录: 'त्वरित लॉगिन',
    绑定Google账号: 'Google खाता बाँधें',
    绑定失败: 'बाइंडिंग विफल',
    支持: 'समर्थन',
    更多: 'अधिक',
    提现次数: '{value} बार',
    '请安装Google Play服务': 'कृपया Google Play सेवाएं स्थापित करें',
    '暂无相册权限，请前往设置开启权限': 'अभी तक कोई एल्बम अनुमति नहीं है, कृपया सेटिंग्स में जाएं और अनुमति खोलें',
    '暂无相机权限，请前往设置开启权限': 'अभी तक कोई कैमरा अनुमति नहीं है, कृपया सेटिंग्स में जाएं और अनुमति खोलें',
    '暂无麦克风权限，请前往设置开启权限': 'अभी तक कोई माइक्रोफ़ोन अनुमति नहीं है, कृपया सेटिंग्स में जाएं और अनुमति खोलें',
    '暂无手机存储权限，请前往设置开启权限': 'अभी तक कोई फ़ोन स्टोरेज अनुमति नहीं है, कृपया सेटिंग्स में जाएं और अनुमति खोलें',
    请输入IFSC码: 'कृपया IFSC कोड दर्ज करें',
    搜索: 'खोज',
    恭喜你: 'बधाई हो',
    用户名或手机号码: 'उपयोगकर्ता नाम या मोबाइल नंबर',
    请输入用户名或手机号码: 'कृपया किसी का उपयोगकर्ता नाम या मोबाइल नंबर दर्ज करें',
    玩法说明: 'खेलने का तरीका',
    截止时间: 'समय सीमा',
    随机投注: 'रैंडम बेट',
    游戏记录: 'खेल रिकॉर्ड',
    图表趋势: 'चार्ट ट्रेंड',
    我的投注记录: 'मेरा बेट रिकॉर्ड',
    期号: 'अंक',
    '大/小': 'बड़ा/छोटा',
    数字: 'संख्या',
    颜色: 'रंग',
    大: 'बड़ा',
    小: 'छोटा',
    '投注助手（过去100期）': 'बेटिंग असिस्टेंट (पिछले 100 अंक)',
    开奖号码: 'जैकपॉट नंबर',
    数量: 'मात्रा',
    我同意: 'मैं सहमत हूँ',
    预售规则详情:
        'पूर्व-बिक्री में भाग लेने वाले उपयोगकर्ताओं के वैध अधिकारों और हितों की रक्षा करने और सामान्य परिचालन आदेश बनाए रखने के लिए, नियमों को प्रासंगिक समझौतों और विनियमों के अनुसार लागू किया जाता है। 1.1 प्री-सेल की परिभाषा: एक बिक्री मॉडल को संदर्भित करता है जिसमें व्यापारी उत्पाद या सेवा समाधान प्रदान करते हैं, उत्पाद प्री-सेल टूल के माध्यम से उपभोक्ता ऑर्डर एकत्र करते हैं, और पूर्व समझौतों के अनुसार उपभोक्ताओं को सामान या सेवाएं प्रदान करते हैं। 1.2 प्री-सेल-सेल मॉडल एक "जमा" मॉडल है। "जमा" का तात्पर्य अग्रिम वितरित माल की पूर्व-बिक्री मूल्य में शामिल निश्चित राशि से है। "डिपॉजिट" आपको मिनी-गेम्स में भाग लेने और अधिक डिपॉजिट जीतने का मौका देता है। जमा राशि का माल के बदले सीधे आदान-प्रदान किया जा सकता है। 1.3 पूर्व-बिक्री उत्पाद: पूर्व-बिक्री उत्पाद उपकरण का उपयोग करके व्यापारियों द्वारा जारी किए गए उत्पादों को संदर्भित करता है। उत्पाद शीर्षक या उत्पाद विवरण पृष्ठ पर केवल प्री-सेल शब्द अंकित है। जो उत्पाद उत्पाद प्री-सेल टूल का उपयोग नहीं करते हैं, वे प्री-सेल उत्पाद नहीं हैं। 1.4 प्री-सेल सिस्टम: व्यापारियों को समर्थन देने के लिए प्रदान किए गए सिस्टम उत्पाद टूल को संदर्भित करता है पूर्व-बिक्री में - बिक्री मॉडल बिक्री 1.5 पूर्व-बिक्री उत्पाद मूल्य: पूर्व-बिक्री उत्पादों के बिक्री मूल्य को संदर्भित करता है। पूर्व-बिक्री माल की कीमत में दो भाग होते हैं: जमा और अंतिम भुगतान।',
    预售规则: 'पूर्व-बिक्री नियम',
    总金额: 'कुल राशि',
    投注金额必须大于0: 'बेट राशि 0 से अधिक होनी चाहिए',
    请同意预售规则: 'कृपया पूर्व-बिक्री नियम स्वीकार करें',
    投注小于最小限额: 'बेट न्यूनतम सीमा से कम है',
    投注大于最大限额: 'बेट अधिकतम सीमा से अधिक है',
    当前期已封盘: 'वर्तमान अंक बंद हो गया है',
    请选择投注内容: 'कृपया बेट सामग्री चुनें',
    投注失败: 'बेट विफल',
    投注成功: 'बेट सफल',
    红色: 'लाल',
    绿色: 'हरा',
    紫色: 'बैंगनी',
    购买金额: 'खरीद राशि',
    购买数量: 'खरीद मात्रा',
    税后金额: 'कर बाद राशि',
    税收: 'कर',
    结果: 'परिणाम',
    选择: 'चयन',
    '输/赢': 'हार/जीत',
    创建时间: 'निर्माण समय',
    'WIN GO彩票': 'WIN GO लॉटरी',
    'WIN GO规则详情':
        'यदि आप व्यापार करने के लिए 100 खर्च करते हैं, तो 2 सेवा शुल्क काटने के बाद, आपके अनुबंध का मूल्य 98:<br/><br/>1 है। हरा चुनें: यदि परिणाम 1,3,7,9 दिखाता है, तो आपको (98*) मिलेगा। 2) 196; यदि परिणाम 5 दिखाता है, तो आपको (98*1.5) 147<br/><br/>2 मिलेगा। यदि परिणाम 2,4,6,8 दिखाता है, तो आपको (98*) मिलेगा। 2) 196; यदि परिणाम 0 दिखाता है, तो आपको (98*1.5) 147<br/><br/>3 प्राप्त होगा। बैंगनी चुनें: यदि परिणाम 0 या 5 दिखाता है, तो आपको (98*4.5) 441< प्राप्त होगा। br/>< br/>4. संख्या चुनें: यदि परिणाम चयनित संख्या के समान है, तो आपको (98*9) 882<br/>5 प्राप्त होगा। यदि परिणाम 5,6 दिखाता है ,7,8,9, आपको (98*2) 196 मिलेंगे<br/><br/>6। छोटा चुनें: यदि परिणाम 0,1,2,3,4 दिखाता है, तो आपको (98*2) मिलेगा ) 196',
    该玩法不允许下注: 'यह खेलने की अनुमति नहीं है',
    总赌注: 'कुल बेट',
    赔率: 'बेटिंग अनुपात',
    选择3个唯一号码: '3 अद्वितीय संख्याएं चुनें',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*यदि खुले नंबर और 3 बेटिंग नंबर मेल खाते हैं, तो जीतने वाले होंगे।',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*यदि जैकपॉट नंबर में से किसी भी तीन नंबर मेल खाते हैं, तो जीतने वाले होंगे।',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*यदि खुले नंबर और 2 बेटिंग नंबर मेल खाते हैं, तो जीतने वाले होंगे। (तीन समान नंबर को छोड़कर)।',
    选择2个相同的数字: '2 समान नंबर चुनें',
    选择一对独特的数字: 'एक अद्वितीय नंबर का चयन करें',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。':
        'कम से कम 1 जोड़े समान नंबर और 1 जोड़े अलग नंबर का चयन करें, यदि खुले नंबर और बेटिंग नंबर मेल खाते हैं, तो जीतने वाले होंगे।',
    选择2个不同的数字: '2 अलग नंबर चुनें',
    选择3个不同的数字: '3 अलग नंबर चुनें',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖': '*3 या अधिक अलग नंबर चुनें। जो भी 3 नंबर चुने गए हैं, वे अलग होने चाहिए और चयन के अनुसार होने चाहिए, तो जीतने वाले होंगे',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。': '*2 या अधिक अलग नंबर चुनें। यदि चुने गए 2 नंबर अलग हैं और चयन के अनुसार हैं, तो जीतने वाले होंगे।',
    '*若开奖号码为三个连续号码，则中奖。': '*यदि जैकपॉट नंबर तीन लगातार नंबर है, तो जीतने वाले होंगे।',
    玩法提示1: '2 समान संख्याएँ चुनें और यदि परिणाम आपके चुने हुए संख्याओं से मेल खाता है, तो आप जीतेंगे (जब तक कि 3 संख्याएँ समान न हों)।',
    玩法提示2: '2 समान संख्याएँ और 1 भिन्न संख्या चुनें, और यदि परिणाम आपके चुने हुए संख्याओं से मेल खाता है, तो आप जीतेंगे।',
    玩法提示3: '3 समान संख्याएँ चुनें और यदि परिणाम आपकी चुनी हुई संख्याओं से मेल खाता है, तो आप जीत जाते हैं।',
    玩法提示4: 'कोई भी 3 समान संख्याएँ चुनें, और यदि परिणाम कोई 3 समान संख्याएँ हैं, तो आप जीतेंगे।',
    玩法提示5: '3 या अधिक भिन्न संख्याएँ चुनें और यदि परिणाम आपकी चुनी हुई संख्याओं से मेल खाता है, तो आप जीत जाते हैं।',
    玩法提示6: 'कोई भी 3 लगातार संख्याएँ चुनें, यदि परिणाम कोई 3 लगातार संख्याएँ हैं, तो आप जीत जाते हैं।',
    玩法提示7: '2 या अधिक भिन्न संख्याएँ चुनें, और यदि परिणाम एक भिन्न संख्या है जो आपके द्वारा चुनी गई संख्या से मेल खाती है, तो आप जीत जाते हैं।',
    K3彩票: 'K3 लॉटरी',
    K3规则详情:
        'जल्दी से 3 पासे बनाएं और प्रत्येक चक्र में 3 नंबर प्राप्त करें। पासों की संख्या में 111 से 666 तक की प्राकृतिक संख्याएं होती हैं। पासों की संख्याएं हमेशा क्रमागत नहीं होती हैं। आप पूरे पासे या पासे के भाग का अनुमान लगा सकते हैं। <br/><br/>कुल मूल्य<br/>3 पासों के मानों का योग अनुमान लगाएं<br/><br/>3 समान संख्याएँ<br/> 3 समान विशेष संख्याओं (111,222) पर दांव लगाएं ,...,666). <br/><br/>2 समान संख्याएं<br/>2 समान संख्याओं पर दांव लगाएं<br/><br/>2 समान संख्याएं + 1 भिन्न संख्या<br/>2 जोड़ी समान संख्या और 1 भिन्न संख्या पर दांव लगाएं <br/><br/>3 अलग-अलग नंबरों पर दांव लगाएं<br/><br/>2 अलग-अलग नंबरों पर दांव लगाएं<br/><br/>2 अलग-अलग नंबरों पर दांव लगाएं<br/><br/>लगातार 3 नंबर नंबर<br/>तीन लगातार नंबरों पर दांव लगाएं<br/>(123, 234, 345, 456) <br/><br/>छोटा (3-11)<br/>बड़ा (12-18)',
    总和: 'कुल योग',
    '奇/偶': 'विषम/सम',
    '2个相同': '2 समान',
    '3个相同': '3 समान',
    '3个连续': '3 लगातार',
    不同数字: 'अलग-अलग संख्याएँ',
    '5D彩票': '5D लॉटरी',
    '5D规则详情':
        'ड्राइंग निर्देश<br/>प्रत्येक अवधि के लिए 5 अंक (00000-99999) यादृच्छिक रूप से चुने जाते हैं<br/>उदाहरण के लिए:<br/>इस अवधि के लिए लॉटरी संख्या 12345 है<br/>A=1<br/>B =2<br />सी=3<br/>डी=4<br/>ई=5<br/>योग=ए+बी+सी+डी+ई=15<br/>कैसे खेलें<br/ >खिलाड़ी छह विभिन्न सट्टेबाजी परिणाम ए, बी, सी, डी, ई और उनकी राशि निर्दिष्ट कर सकते हैं<br/>ए, बी, सी, डी, ई सभी खरीदे जा सकते हैं<br/>मात्रा (0 1 2 3 4 5 6 7 8 9)<br/ />कम (0 1 2 3 4)<br/>अजीब (1 3 5 7 9)<br/>उच्च (5 6 7 8 9)<br/>अजीब (1 3 5 7 9)<br/>सम संख्याएं (0 2 4 6 8)<br/>योग = ए+बी+सी+डी+ई खरीद के लिए उपलब्ध<br/>कम (0-22)<br/>उच्च ( 23-45)<br/>विषम संख्याएं (1 3 …43 45)<br/>जोड़ी (0 2 …42 44)',
    下拉即可刷新: 'ताज़ा करने के लिए नीचे खींचें',
    释放即可刷新: 'ताज़ा करने के लिए रिलीज़ करें',
    没有更多了: 'अब और नहीं',
    试玩提示: 'आप एक परीक्षण अनुभव में प्रवेश कर रहे हैं; लाभ कमाने के बाद निकासी उपलब्ध नहीं है',
    分享链接: 'लिंक शेयर करें',
    应用已更新: 'एप्लिकेशन अपडेट किया गया है',
    点击确定重启App生效: 'सुनिश्चित करने के लिए एप्लिकेशन को पुनः आरंभ करें',
    热门: 'लोकप्रिय',
    最近: 'हाल ही में',
    收藏: 'कलेक्ट',
    邀请好友帮忙提现: '1. निकासी में मदद के लिए दोस्तों को आमंत्रित करें',
    向随机玩家发送邀请以提供帮助: '2. मदद के लिए किसी यादृच्छिक खिलाड़ी को आमंत्रण भेजें',
    通过短信发送消息: 'पर संदेश भेजें ',
    短信: 'SMS',
    今天剩余提款额度: 'आज की शेष निकासी राशि',
    VIP每日限额: 'VIP दैनिक सीमा',
    今天剩余提款次数: 'आज शेष निकासी की संख्या',
    VIP每日提款次数: 'VIP दैनिक निकासी',
    单笔最小提款: 'एकल न्यूनतम निकासी',
    单笔最大提款: 'अधिकतम एकल निकासी',
    USDT地址: 'USDT पता',
    今天提款次数已用完: 'निकासी की संख्या आज समाप्त हो गई है',
    提现提示: 'निकासी युक्तियाँ',
    系统异常: 'सिस्टम अपवाद',
    '你好，我们有一份礼物送给你': 'नमस्ते, हमारे पास आपके लिए एक उपहार है',
    请输入礼品代码: 'कृपया उपहार कोड दर्ज करें',
    奖金金额: 'बोनस राशि: {value}',
    关注官方渠道获取代码: 'कोड प्राप्त करने के लिए आधिकारिक चैनल का अनुसरण करें',
    '该金额暂无可用的充值通道,请更换充值金额': 'इस राशि के लिए कोई रिचार्ज चैनल उपलब्ध नहीं है। कृपया रिचार्ज राशि बदलें।',
    联系客服: 'ग्राहक सेवा से संपर्क करें',
    上月: 'पिछले महीने',
    礼物: 'उपहार',
    公链查询: 'पब्लिक चेन क्वेरी',
    区块: 'ब्लॉक',
    区块时间: 'ब्लॉक समय',
    哈希: 'हैश',
    trx详情:
        'हैश वैल्यू क्या है?<br/><br/>बिटकॉइन की मूल बातें जानने वाला कोई भी व्यक्ति एक अवधारणा से अवगत होगा, हैश वैल्यू। बिटकॉइन के ब्लॉक हेडर में पिछले ब्लॉक का हैश होता है, जिसका उपयोग पिछले ब्लॉक को इंगित करने के लिए किया जाता है।<br/><br/>हैश अंग्रेजी हैश का लिप्यंतरण है, हम इसे हैश में भी अनुवाद कर सकते हैं, इसलिए हैश वैल्यू को हैश वैल्यू भी कहा जाता है। एक हैश वैल्यू एक हैश फ़ंक्शन (या हैश फ़ंक्शन/हैश एल्गोरिथम) के साथ गणना की गई वैल्यू है। हैश वैल्यू को समझने के लिए, किसी को हैश फ़ंक्शन की प्रकृति को समझना चाहिए। एक हैश फ़ंक्शन कम्प्यूटेशनल रूप से मनमाने लंबाई के इनपुट को निश्चित लंबाई के आउटपुट में बदल सकता है।<br/><br/>प्रत्येक हैश फ़ंक्शन में यह गुण होता है कि यदि इनपुट मान समान है, तो आउटपुट हैश मान समान होता है यदि इनपुट मान में मामूली बदलाव से हैश टकराव से इंकार किया जाता है, तो पूरी तरह से असंबंधित हैश मान आउटपुट होता है। चूंकि हैश फ़ंक्शन अपरिवर्तनीय और सत्यापित करने में आसान है, इसलिए आउटपुट हैश मान के माध्यम से इनपुट मान को उलटना लगभग असंभव है। यदि कोई इनपुट मान है, तो संबंधित हैश मान को तुरंत सत्यापित किया जा सकता है।<br/><br/>इसलिए, प्रत्येक ब्लॉक का हैश मान अद्वितीय, यादृच्छिक, अटूट, अक्षम्य होता है, ब्लॉक हैश मान स्वचालित रूप से पहचाना जाता है, और रिकॉर्ड के साथ छेड़छाड़ नहीं की जा सकती है।<br/><br/>USDT कितने प्रकार के होते हैं?<br/><br/>1. बिटकॉइन नेटवर्क पर आधारित ओमनी-यूएसडीटी, जमा पता बीटीसी पता है, और जमा और निकासी बीटीसी नेटवर्क से होते हैं;<br/><br/>2. ईआरसी20-यूएसडीटी TRC20-USDT TRON TRC20 प्रोटोकॉल और TRX (TRON) नेटवर्क पर आधारित है, जमा पता TRON पता है, और जमा और निकासी TRON नेटवर्क के माध्यम से होती है।<br/><br/>TrxHash TRC20-USDT ब्लॉक हैश है जो TRON TRC20 प्रोटोकॉल और TRX (TRON) नेटवर्क पर आधारित है। अंतिम संख्या का उपयोग लॉटरी के परिणाम के रूप में किया जाता है ताकि यह निर्धारित किया जा सके कि आपने लॉटरी जीती है या नहीं (अद्वितीय ब्लॉक हैश की क्वेरी करने के लिए सार्वजनिक श्रृंखला पर जाने के लिए ब्लॉक ऊंचाई पर क्लिक करें)<br/><br/>खेल के नियम इस प्रकार हैं:<br/><br/>1. 1 मिनट के लिए 1 लॉटरी ड्रा, 45 सेकंड के भीतर खरीद, और परिणाम खोलने से पहले 15 सेकंड के भीतर खरीद नहीं की जा सकती।<br/><br/>2. पूरे दिन खरीद अनलॉक। एक दिन में खरीद की कुल संख्या 1440 है।<br/><br/>3. 3 अंक 1 बार, 5 अंक 1 बार, 10 अंक 1 बार, नियम 1 अंक 1 बार के समान हैं सिवाय इसके कि ड्रा का समय अलग है।<br/><br/>4. ब्लॉक हैश का अंतिम अंक लॉटरी परिणाम के रूप में उपयोग किया जाता है:<br/><br/>उदाहरण:<br/><br/>यदि हैश मान **b569 है, तो लॉटरी परिणाम 9 होगा<br/><br/>हैश मान **d14c, लॉटरी परिणाम 4 होगा<br/><br/>यदि आप व्यापार करने के लिए 100 खर्च करते हैं, तो सेवा शुल्क 2% काटने के बाद, अनुबंध राशि: 98<br/><br/>l हरा चुनें: यदि परिणाम 1,3,7,9 दिखाता है, तो आपको (98 * 2) =196 मिलेगा; यदि परिणाम 5 दिखाता है, तो आपको (98 * 2) = 196 मिलेगा<br/><br/>l लाल चुनें: यदि परिणाम 2,4,6,8 दिखाता है, तो आपको (98 * 2) =196 मिलेगा; यदि परिणाम 0 दिखाता है, तो आपको (98 * 2) = 196 मिलेगा<br/><br/>l बैंगनी चुनें: यदि परिणाम 0 या 5 दिखाता है, तो आपको (98 * 2) = 196 मिलेगा<br/><br/>l संख्या का चयन करें: यदि खोलने का परिणाम आपके द्वारा चुने गए के समान है, तो आपको (98 * 9) = 882 मिलेगा<br/><br/>l बड़ा चुनें: यदि परिणाम 5,6,7,8,9 दिखाता है तो आपको (98 * 2) = 196 मिलेगा<br/><br/>l छोटा चुनें: यदि परिणाम 0,1,2,3,4 दिखाता है तो आपको (98 * 2) = 196 मिलेगा',
    'WIN TRX彩票': 'WIN TRX लॉटरी',
    确认进入游戏吗: 'क्या आप खेल में प्रवेश करना चाहते हैं?',
    奖励兑换码: 'पुरस्कार कोड',
    注册时间: 'रजिस्टर टाइम',
    '7 天全额存款': '<span>{value}</span> दिन पूर्ण जमा',
    何时可以领取奖金: 'जब आप इसे प्राप्त कर सकते हैं',
    神秘奖金: 'गुप्त पुरस्कार',
    活动已过期: 'गतिविधि समाप्त हो गई है',
    已领取: 'प्राप्त',
    首次存款: 'पहली जमा',
    活动说明: 'गतिविधि विवरण',
    等级优惠: 'स्तर की छूट',
    当前等级: 'वर्तमान स्तर',
    铁: 'लोहा',
    青铜: 'कॉपर',
    白银: 'सिल्वर',
    黄金: 'गोल्ड',
    铂金: 'प्लेटिनम',
    钻石: 'डायमंड',
    近7天游戏营业额: 'अगार्ज {value} दिनों में खेल का आयात',
    未达成: 'पूर्ण नहीं है',
    已申请: 'आवेदन किया गया है',
    已收到: 'प्राप्त',
    保存: 'बचाना',
    每周奖金: 'साप्ताहिक बोनस',
    领取时间: 'संग्रह का समय',
    加载更多: 'और लोड करें',
    游戏大厅: 'खेल लॉबी',
    更多游戏: 'अधिक खेल',
    底部描述:
        '{value} को {value2} कंपनी पंजीकरण संख्या 142922 द्वारा संचालित किया जाता है, जिसका पंजीकृत पता Zuikertuintjeweg Z/N (Zuikertuin Tower) Curacao में है और इसे Curacao सरकार द्वारा लाइसेंस और अधिकृत किया गया है। {value} गेमिंग सेवा प्रदाता, N.V. के मास्टर लाइसेंस के तहत संचालित होता है। लाइसेंस संख्या: GLH-OCCHKTW065752688',
    底部描述2:
        ' <p>1. यह उत्पाद 18 वर्ष या उससे अधिक आयु के उपयोगकर्ताओं द्वारा उपयोग के लिए है और केवल मनोरंजन के उद्देश्य से है।</p><p>2. इस गेम में इन-ऐप खरीदारी शामिल है।</p><p>3. यह तथ्य कि कोई खिलाड़ी सामाजिक जुए के खेल में खेलता है या जीतता है, इसका मतलब यह नहीं है कि वह भविष्य में असली पैसे के जुए और संबंधित खेलों में जीतेगा।</p>',
    版权声明: '{value} {value2}. सभी अधिकार सुरक्षित। 18+',
    支付成功: 'भुगतान सफल',
    最大掉落: 'एक समय में अधिकतम {value} ड्रॉप',
    每天几次: 'दिन में {value} बार',
    当前输赢: 'वर्तमान हानि',
    当前可领金额: 'वर्तमान राशि उपलब्ध है',
    上一期输赢: 'पिछले अंक का नुकसान',
    上一期可领金额: 'पिछली अवधि के लिए उपलब्ध राशि',
    赎回基金表: 'मोचन निधि तालिका',
    比赛失败: 'गेम विफल',
    赎回费用: 'मोचन शुल्क',
    救援金: 'सहायता कोष',
    本周补偿: 'इस सप्ताह के लिए मुआवजा',
    本周盈利: 'इस सप्ताह लाभ',
    可获得补偿: 'मुआवज़ा उपलब्ध है',
    本周的补偿将分配到: 'इस सप्ताह का मुआवजा वितरित किया जाएगा',
    每周报酬: 'साप्ताहिक मुआवज़ा',
    补偿: 'मुआवज़ा',
    累计投注: 'संचित दांव',
    通过累积投注提升VIP等级: 'दांव जमा करके वीआईपी स्तर को अपग्रेड करें',
    立即下载: 'अभी डाउनलोड करें',
    下载应用程序: 'ऐप डाउनलोड करें',
    您要下载并安装APP吗: 'क्या आप ऐप डाउनलोड और स्थापित करना चाहते हैं?',
    暂无可用手机号: 'अभी तक कोई मोबाइल फ़ोन नंबर उपलब्ध नहीं है',
    '下载地址不存在，请稍后重试': 'डाउनलोड पता मौजूद नहीं है, कृपया बाद में फिर से आगे बढ़ें',
    '下载已开始，请在通知栏查看下载进度': 'डाउनलोड शुरू हो गया है, कृपया नोटिफिकेशन बार में डाउनलोड प्रगति देखें',
    '下载失败，请稍后重试': 'डाउनलोड विफल, कृपया बाद में फिर से आगे बढ़ें',
    支付倒计时: 'कृपया {value} में भुगतान पूरा करें',
    支付方式: 'भुगतान तरीका',
    钱包支付: 'वालेट भुगतान',
    取消充值申请: 'जमा अनुरोध रद्द करें',
    查看充值记录: 'जमा रिकॉर्ड देखें',
    打开App: 'ऐप खोलें {value}',
    每日游戏收入: 'दिन में खेल का आयात',
    签到奖金: 'साइन इन बोनस',
    手机号首位不能为0: 'मोबाइल नंबर का पहला अक्षर 0 नहीं हो सकता है',
    真实姓名只能包含英文字母和空格: 'वास्तविक नाम केवल अक्षरों और स्थान हो सकते हैं',
    请输入正确的银行卡账号: 'कृपया एक वैध बैंक खाता नंबर दर्ज करें',
    请输入15位仅包含数字和字母的账号: 'कृपया 15 अंकीय खाता संख्या दर्ज करें जिसमें केवल अक्षर या अंक हों',
    请输入CLABE账号: 'कृपया CLABE खाता दर्ज करें',
    请输入正确的CLABE账号: 'कृपया एक वैध CLABE खाता दर्ज करें',
    利息: 'ब्याज',
    转入金额必须大于: 'स्थानांतरण राशि {value} से अधिक होनी चाहिए',
    最小金额为: 'न्यूनतम {value}, केवल पूर्णांक',
    已转入: 'लोड किया गया',
    年利率: 'वार्षिक ब्याज दर {value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span> रिज़ॉल्यूशन साइकल (अधिकतम <span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span> लंबित <span style="color: var(--profit-text-warning);"> {value} </span> (पूर्ण {value2}) </span>`,
    收取: 'प्राप्त करें',
    累计收益: 'संचित राजस्व <span style="color: var(--profit-text-warning);"> {value}</span>',
    交易类型: 'लेनदेन प्रकार',
    奖金: 'बोनस',
    详细资料: 'विस्तृत प्रोफ़ाइल',
    规则说明: 'देखभाल के नियम',
    解决周期: 'रिज़ॉल्यूशन साइकल',
    转账金额: 'स्थानांतरण राशि',
    当前时间: 'वर्तमान समय',
    存款利息结算: 'इस जमा के बाद, पहला ब्याज {value} पर दिखाई देगा',
    确认转账: 'स्थानांतरण की पुष्टि',
    当前储蓄本: 'वर्तमान बचत पुस्तक',
    转出金额: 'स्थानांतरित राशि',
    本次循环的倒计时: 'इस चक्र के लिए उलटी गिनती का समय',
    提取利息提示: 'एक बार निकालने पर, आप इस चक्र का ब्याज खो देंगे!',
    确认提现: 'निकासी की पुष्टि करें',
    转入: 'स्थानांतरित करें',
    账户余额: 'खाता शेष',
    提款最小金额: 'न्यूनतम निकासी राशि {value}',
    提取金额必须大于: 'निकासी राशि {value} से अधिक होनी चाहिए',
    提取金额不能超过账户金额: 'निकासी राशि खाता शेष से अधिक नहीं हो सकती',
    提取成功: 'निकासी सफल',
    提取失败: 'निकासी विफल',
    转入成功: 'स्थानांतरित सफल',
    转入失败: 'स्थानांतरित विफल',
    无限: 'अनिश्चित',
    时: '{value} घंटा',
    分: '{value} मिनट',
    秒: '{value} सेकंड',
    利息宝未开启: 'ब्याज खोला नहीं गया है',
    已完成: 'पूरा हो गया है',
    处理中: 'प्रकार में है',
    已取消: 'अनुरोध रद्द कर दिया गया है',
    已提交: 'जमा किया गया है',
    审核中: 'समीक्षा में है',
    出款中: 'निकासी में है',
    出款失败: 'निकासी विफल',
    已审核: 'समीक्षा पूरी हो गई है',
    补单成功: 'अद्यतन जमा सफल',
    补单失败: 'अद्यतन जमा विफल',
    请输入UTR: 'UTR दर्ज करें',
    请输入数字和字母: 'संख्या और अक्षर दर्ज करें',
    补单: 'अद्यतन जमा',
    请输入12位数字: '12 अक्षर की संख्या दर्ज करें',
    最多只能选择9个号码: 'अधिकतम 9 संख्या चुनें',
    请选择支付方式: 'भुगतान तरीका चुनें',
    用户ID: 'उपयोगकर्ता ID/फ़ोन नंबर',
    总余额: 'कुल शेष',
    提现余额: 'निकासी शेष',
    请输入用户ID: 'कृपया उपयोगकर्ता ID/फ़ोन नंबर दर्ज करें',
    TelegramChannel: 'Telegram चैनल',
    真实姓名的长度不小于5个字符: 'वास्तविक नाम की लंबाई कम से कम 5 अक्षर होनी चाहिए',
    下载: 'डाउनलोड',
    强度: 'शक्ति',
    余额不足: 'पर्याप्त शेष नहीं',
    客服: 'समर्थन',
    有效投注总额: "कुल मान्य शर्तें",
    盈亏总额: "कुल लाभ और हानि",
    注册账户: 'खाता रजिस्टर करें',
    注册完成后可获得奖励: 'पंजीकरण पूरा करने के बाद, आप <span class="intro-highlight">प्राप्त कर सकते हैं {value}</span> पुरस्कार',
    
    // तृतीय-पक्ष लॉगिन संबंधित
    第三方登录: 'तृतीय-पक्ष लॉगिन',
    登录方式: 'लॉगिन के साथ',
    
    // कॉलबैक पेज लोडिंग संबंधित
    '正在处理登录...': 'लॉगिन प्रक्रिया में...',
    '请稍候，即将为您跳转': 'कृपया प्रतीक्षा करें, रीडायरेक्ट हो रहा है...',
    赠送中心: 'उपहार केंद्र',
    截止日期: 'समाप्त तिथि',
    返回顶部: 'ऊपर जाएं',
    游戏: 'खेल',
    搜索游戏: 'खेल खोजें',
    下注成功: 'दांव सफल',
    下注失败: 'दांव विफल',
    游戏历史: 'खेल इतिहास',
    期数: 'अवधि',
    存款宝箱: 'जमा खजाना',
    归回累存: 'वापसी जमा संचय',
    统计截至: 'आंकड़े यहाँ तक',
    剩余天数: 'शेष दिन',
    当前累计: 'वर्तमान संचय',
    距: 'तक',
    还差: 'अभी बाकी',
    当前可领取: 'अभी दावा योग्य',
    档: 'स्तर',
    累计门槛: 'संचयी सीमा',
    赠送金额: 'बोनस राशि',
    打码: 'टर्नओवर आवश्यकता',
    可提前领取: 'समय से पहले दावा किया जा सकता है। दावा करने के बाद उच्च स्तर प्राप्त नहीं किया जा सकता',
    活动进行中: 'इवेंट जारी है',
    活动到期领取: 'इवेंट जारी है। इवेंट समाप्त होने के बाद पुरस्कार का दावा किया जा सकता है',
    第几天: 'दिन {value}',
    已于第几天领取: 'दिन {value} को <strong>{value1}</strong> प्राप्त किया',
    几天: '{value} दिन',
    回归每日首存: 'वापसी करने वाले उपयोगकर्ता की दैनिक पहली जमा',
    今日时间: 'आज का समय',
    今日首笔存款: 'आज की पहली जमा',
    可用奖金: 'उपलब्ध बोनस',
    奖金比例: 'बोनस प्रतिशत',
    立即领取: 'अभी प्राप्त करें',
    去充值: 'जमा करें',
    查看活动: 'इवेंट देखें',
    再充值一点更划算: 'बेहतर इनाम के लिए थोड़ा और जमा करें',
    当前档: 'वर्तमान स्तर',
    冲刺档: 'लक्ष्य स्तर',
    冲: 'और जोड़ें',
    直接领取当前奖励: 'अभी {value} प्राप्त करें',
    活动结束: 'इवेंट समाप्त',
    恭喜领取成功: 'इनाम सफलतापूर्वक प्राप्त हुआ',
    累计奖励已入账户: 'संचित इनाम {value} खाते में जमा हो गया है',
    请完成打码流水后提现: 'निकासी से पहले टर्नओवर आवश्यकता पूरी करें',
    知道了: 'समझ गया',
    去下注: 'अभी दांव लगाएँ',
    充值后最高赠送: 'जमा करने के बाद अधिकतम बोनस: {value}',
    倍数: 'गुणक',
    必须通过此页面充值才能获得多倍奖金: 'गुणक बोनस पाने के लिए आपको इसी पेज से जमा करना होगा',
    已领取宝箱金额: 'चेस्ट इनाम प्राप्त हुआ',
    已领取翻倍奖励: '{value} गुना बोनस प्राप्त हुआ',
    充值领取最高: 'जमा करके अधिकतम {multiple} गुना, {value} इनाम पाएँ',
    说明: 'निर्देश',
    翻倍充值说明: 'गुणक जमा निर्देश',
    参与活动: 'इवेंट में भाग लें',
    领取额外奖励: 'अतिरिक्त इनाम प्राप्त करें',
    开始时间: 'प्रारंभ समय',
    流水倍数: 'दांव गुणक',
    打开: 'खोलें',
    继续领取: 'प्राप्त करना जारी रखें',
    翻倍领取: 'गुणक इनाम प्राप्त करें',
};
